import Vue from "vue";
import ApiService from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import moment from "moment";
import { mapGetters } from "vuex";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import { bus } from "../../../main";
import api from "../../../services/api";

export default {
	extends: gridClientBase,
	components: {},
	data: () => {
		return {
			vehicleIdFilterField: "number_plate",
			isAlertDetailInEditMode: false,
			alertId: 0,

			vehicles: [],
			groups: [],
			groupsDataFilters: [],
			groupsDataFiltersSelected: [],
			divisions: [],
			divisionsFilter: [],
			divisionsFilterSelected: [],
			plateNumberFilters: [],
			plateNumberFilterSelected: [],

			alertVehicleTypes: [],
			alertVehicleTypesSelected: null,

			id: 0,
			enabled: false,
			realtime_box: false,
			frequency: 0,
			minimun_frequency_box: 0,
			maximun_frequency_box: 0,
			instance_id: 0,
			recipients: "",
			recipients_Bcc: "",
			sms_numbers: "",
			subject: "",
			message: "",
			name: "",
			notes: "",
			type_box: "",
			type_box_id: 0,
			vehicle_association_box: false,

			custom_params_type_box: 0, //no parameter to add; 1: one parameter to add - type numeric; +1 reserved to future;
			custom_param1: 0, //
			days: [],

			saveAlertVechilesAssociationRequest: null,

			itemTemplate: "<div style='height: 50px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			valueTemplate: "#= number_plate #",

			alertTypes: [],

			geofenceVehicleItems: [],
			savePendingRequest: null,
			hasDivisions: false,

			columnsTable: [],

			options: {
				messages: {
					hour: "HH",
					minute: "mm"
				}
			},

			errorsStartTime: [false, false, false, false, false, false, false],
			errorsEndTime: [false, false, false, false, false, false, false]
		};
	},

	created() {
		this.alertId = this.$route.params.id;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		this.columnsTable = [
			{
				field: "type_name",
				title: "Tipo Associazione",
				headerCell: "myHeaderTemplate",
				filterable: true,
				cell: "myalertVehicleTypesCellTemplate"
			},
			{
				field: "vehicle_name",
				title: this.vehicleIdFilterField == "code" ? "codice" : "targa",
				headerCell: "myVehicleNumberPlateHeaderTemplate",
				cell: "numberPlateCellTemplate",
				filterable: true
			},
			{
				field: "group_name",
				title: "Gruppo",
				headerCell: "myGroupsHeaderTemplate",
				cell: "myGroupsCellTemplate",
				filterable: true
			}
		];

		if (this.settings && this.settings.hasDivisions) {
			this.columnsTable.push({
				field: "division_name",
				title: "Divisione",
				headerCell: "myDivisionsHeaderTemplate",
				cell: "myDivisionsCellTemplate",
				filterable: true
			});
			this.hasDivisions = true;
		}

		this.columnsTable.push({
			cell: "myCellDeleteTemplate",
			width: "45px",
			sortable: false,
			headerCell: "myHeaderTemplate"
		});

		var newItem = {
			id: 0,
			alert_id: this.alertId,
			type: 0,

			vehicle_id: 0,
			group_id: 0,
			division_id: 0,
			error: false,
			recipients: "",
			recipients_Bcc: "",
			sms_numbers: ""
		};

		this.defaultAddRow = newItem;

		try {
			let optionsMessages = kendo.widgets.find(function(item) {
				return item.name == "kendoDateInput";
			});
			optionsMessages.widget.fn.options.messages.hour = "HH";
			optionsMessages.widget.fn.options.messages.minute = "mm";
		} catch (ex) {
			//do nothing
		}

		this.getAlertTypes();
		this.getAlertVehicleTypes();
		this.getAllVehicles();
		this.getGroups();
		if (this.hasDivisions) this.getDivisions();
	},

	mounted() {},

	beforeDestroy() {
		try {
			var optionsMessages = kendo.widgets.find(function(item) {
				return item.name == "kendoDateInput";
			});
			optionsMessages.widget.fn.options.messages.hour = "hours";
			optionsMessages.widget.fn.options.messages.minute = "minutes";
		} catch (ex) {
			//do nothing
		}
	},

	methods: {
		onFrequencyChange(e) {
			if (e.sender.value() || e.sender.value() == 0) {
				this.frequency = e.sender.value();
				return;
			}

			this.frequency = 0;
		},
		// onMinFrequencyChange(e) {
		// 	if (e.sender.value() || e.sender.value() == 0) {
		// 		this.minimun_frequency_box = e.sender.value();
		// 		return;
		// 	}

		// 	this.minimun_frequency_box = 0;
		// },
		// onMaxFrequencyChange(e) {
		// 	if (e.sender.value() || e.sender.value() == 0) {
		// 		this.maximun_frequency_box = e.sender.value();
		// 		return;
		// 	}

		// 	this.maximun_frequency_box = 0;
		// },
		onCustomParam1Change(e) {
			if (e.sender.value() || e.sender.value() == 0) {
				this.custom_param1 = e.sender.value();
				return;
			}

			this.custom_param1 = null;
		},
		getAlertTypes() {
			var self = this;

			api.getAlertTypes().then(res => {
				self.alertTypes = res.map(function(type) {
					return {
						id: type.key,
						value: type.value
					};
				});
			});

			self.getData();
		},
		internalFiltersToUpdate(e) {
			if (e.field == "vehicle_name") {
				this.plateNumberFilterSelected = [];
			}
			if (e.field == "group_name") {
				this.groupsDataFiltersSelected = [];
			}
			if (e.field == "division_name") {
				this.divisionsFilterSelected = [];
			}
		},
		getAlertVehicleTypes() {
			var self = this;
			ApiService.getAlertVehicleTypes().then(res => {
				self.alertVehicleTypes = res.map(function(item) {
					return {
						id: item.key,
						value: item.value
					};
				});
			});
		},
		isNumber: function(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		addRowItem(e) {
			this.addItem(e);

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		removeRow(e) {
			this.remove(e);

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (
							(item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) ||
							(item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) ||
							(item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id)
						) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onTypeChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newType = this.alertVehicleTypes.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.type = newType.id;
			}

			//preload value based on type selected
			if (newType && newType.id == 0) {
				if (this.vehicles && this.vehicles.length > 0) {
					row.vehicle_id = this.vehicles[0].id;
				}

				row.group_id = null;
				row.division_id = null;
			} else if (newType && newType.id == 1) {
				if (this.groups && this.groups.length > 0) {
					row.group_id = this.groups[0].id;
				}

				row.vehicle_id = null;
				row.division_id = null;
			} else if (newType && newType.id == 2) {
				if (this.divisions && this.divisions.length > 0) {
					row.division_id = this.divisions[0].id;
				}

				row.vehicle_id = null;
				row.group_id = null;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (
							(item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) ||
							(item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) ||
							(item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id)
						) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onVehicleChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newVehicle = this.vehicles.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.vehicle_id = newVehicle.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onGroupChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newGroup = this.groups.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.group_id = newGroup.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onDivisionChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newDivision = this.divisions.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.division_id = newDivision.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},

		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate ? vehicle.number_plate : "",
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});

				self.getVehiclesByAlertId();

				self.vehicles = self._.sortBy(self.vehicles, function(vc) {
					return vc.number_plate.toLowerCase();
				});

				for (var i = 0; i < self.vehicles.length; i++) {
					var vehicle = self.vehicles[i];

					if (vehicle.number_plate) {
						var alreadyExist =
							self.plateNumberFilters.findIndex(item => {
								return item.id == vehicle.number_plate;
							}) >= 0;
						if (!alreadyExist) {
							self.plateNumberFilters.push({
								id: vehicle.number_plate,
								value: vehicle.number_plate
							});
						}
					}
				}

				if (self.vehicles && self.vehicles.length > 0) {
					self.defaultAddRow.vehicle_id = self.vehicles[0].id;
				}
			});
		},
		getGroups: function() {
			var self = this;
			return new Promise(function(resolve, reject) {
				ApiService.getGroupsData()
					.then(res => {
						self.groups = res.map(function(item) {
							return {
								id: item.id,
								value: item.name ? item.name.toLowerCase() : ""
							};
						});

						self.groups = self._.sortBy(self.groups, ["value"]);
						self.groupsDataFilters = JSON.parse(
							JSON.stringify(
								self.groups.map(item => {
									return {
										id: item.value,
										value: item.value
									};
								})
							)
						);

						resolve();
					})
					.catch(err => {
						reject();
					});
			});
		},
		getDivisions() {
			var self = this;
			api.getDivisionsData().then(res => {
				self.divisions = self._.sortBy(
					res
						.filter(function(dv) {
							return dv.name.length > 0;
						})
						.map(function(item) {
							return {
								id: item.id,
								value: item.name.toLowerCase()
							};
						}),
					function(dv) {
						return dv.value;
					}
				);

				self.divisionsFilter = JSON.parse(
					JSON.stringify(
						self.divisions.map(item => {
							return {
								id: item.value,
								value: item.value
							};
						})
					)
				);
			});
		},
		getVehiclesByAlertId: function() {
			var self = this;
			var alertId = this.alertId;

			ApiService.getVehiclesByAlertId(alertId).then(res => {
				if (self._.isNull(res) === false && self._.isUndefined(res) === false && self._.isArray(res) && res.length > 0) {
					self.items = res.map(function(item) {
						return {
							id: item.id,
							alert_id: item.alert_id,
							type: item.type,
							type_name: self.getTypeAssociationById(item.type),
							vehicle_id: item.vehicle_id ? item.vehicle_id : self.vehicles ? self.vehicles[0].id : null,
							vehicle_name: self.getVehiclePlateCodeById(item.vehicle_id),
							division_id: item.division_id ? item.division_id : self.divisions && self.divisions.length > 0 ? self.divisions[0].id : null,
							division_name: self.getDivisionNameById(item.division_id),
							group_id: item.group_id ? item.group_id : self.groups && self.groups.length > 0 ? self.groups[0].id : null,
							group_name: self.getGroupNameById(item.group_id),
							recipients: item.recipients,
							recipients_Bcc: item.recipients_Bcc,
							sms_numbers: item.sms_numbers
						};
					});
				}
			});
		},
		getData() {
			var self = this;
			var alertId = this.alertId;

			ApiService.getAlertDetailData(alertId)
				.then(res => {
					if (self._.isNull(res.data) === false) {
						let data = res;

						self.id = data.id;
						self.enabled = data.enabled;
						self.realtime_box = data.realtime_box;
						self.frequency = data.frequency;
						self.minimun_frequency_box = data.minimun_frequency_box;
						self.maximun_frequency_box = data.maximun_frequency_box;
						self.instance_id = data.instance_id;
						self.recipients = data.recipients;
						self.recipients_Bcc = data.recipients_Bcc;
						self.sms_numbers = data.sms_numbers;
						self.subject = data.subject;
						self.message = data.message;
						self.name = data.name;
						self.notes = data.notes;
						self.type_box = self.getDescriptionByTypeId(data.type_box);
						self.type_box_id = data.type_box;
						self.vehicle_association_box = data.vehicle_association_box;
						self.custom_params_type_box = data.custom_params_type_box;
						self.custom_param1 = data.custom_param1;
						self.days = data.days;
					}

					if (self.frequency < self.minimun_frequency_box) self.frequency = self.minimun_frequency_box;
					if (self.frequency > self.maximun_frequency_box) self.frequency = self.maximun_frequency_box;

					switch (self.type_box_id) {
						case 2:
							var fieldAlreadyAdded = self.columns.find(function(item) {
								return item.field == "sms_numbers";
							});

							if (!fieldAlreadyAdded) {
								self.columns.splice(self.columns.length - 1, 0, {
									field: "sms_numbers",
									title: "Destinatari sms",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
							}
							break;
						case 1:
							var fieldAlreadyAdded = self.columns.find(function(item) {
								return item.field == "recipients";
							});

							if (!fieldAlreadyAdded) {
								self.columns.splice(self.columns.length - 1, 0, {
									field: "recipients",
									title: "Destinatari",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
								self.columns.splice(self.columns.length - 1, 0, {
									field: "recipients_Bcc",
									title: "Destinatari in copia",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
							}
							break;
						default:
							var fieldAlreadyAdded = self.columns.find(function(item) {
								return item.field == "sms_numbers";
							});

							if (!fieldAlreadyAdded) {
								self.columns.splice(self.columns.length - 1, 0, {
									field: "recipients",
									title: "Destinatari",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
								self.columns.splice(self.columns.length - 1, 0, {
									field: "recipients_Bcc",
									title: "Destinatari in copia",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
								self.columns.splice(self.columns.length - 1, 0, {
									field: "sms_numbers",
									title: "Destinatari sms",
									headerCell: "myHeaderTemplate",
									cell: "myCellTemplateNotRequired",
									filterable: true
								});
							}
							break;
					}
				})
				.catch(err => {
					//do nothing
				});
		},
		getDescriptionByTypeId(typeId) {
			if (this.alertTypes && this.alertTypes.length > 0) {
				let type = this.alertTypes.find(function(item) {
					return item.id == typeId;
				});

				if (type && type.value) return type.value;
			}

			return typeId;
		},
		getDescriptionOfPoisSelected(pois) {
			var self = this;
			if (pois && pois.length > 0) {
				let poiKV = pois.map(function(item) {
					return {
						key: item,
						value: self.getPoiName(item)
					};
				});

				return poiKV;
			}

			return null;
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(it) {
					return it.value ? it.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		switcAlertDetailEditMode() {
			this.isAlertDetailInEditMode = !this.isAlertDetailInEditMode;

			if (!this.isAlertDetailInEditMode) {
				this.getData();
			}

			this.savePendingRequest = null;
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getVehiclesByAlertId();
			}else {
				for (var i = 0; i < this.items.length; i++) {
					var row = this.items[i];

					if (row.type == 0) {
						row.group_id = null;
						row.division_id = null;
					} else if (row.type == 1) {
						row.vehicle_id = null;
						row.division_id = null;
					} else if (row.type == 2) {
						row.vehicle_id = null;
						row.group_id = null;
					}
				}
			}

			this.saveAlertVechilesAssociationRequest = null;
		},
		saveAlertDetail() {
			var self = this;

			var data = {
				id: this.id,
				enabled: this.enabled,
				frequency: this.frequency,
				// minimun_frequency_box: this.minimun_frequency_box,
				// maximun_frequency_box: this.maximun_frequency_box,
				recipients: this.recipients,
				recipients_Bcc: this.recipients_Bcc,
				sms_numbers: this.sms_numbers,
				subject: this.subject,
				message: this.message,
				notes: this.notes,
				custom_param1: this.custom_param1 || this.custom_param1 == 0 ? this.custom_param1 : null,
				days: this.days
			};

			if (this.savePendingRequest == null) {
				this.savePendingRequest = ApiService.saveAlertDetail(data)
					.then(res => {
						self.isAlertDetailInEditMode = false;
						self.getData();
					})
					.catch(err => {})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},
		saveAlertVehiclesData() {
			var self = this;

			var createdItemsNormilized = [];
			for (let i = 0; i < this.createdItems.length; i++) {
				let item = this._.clone(this.createdItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				createdItemsNormilized.push(item);
			}

			var updatedItemsNormilized = [];
			for (let i = 0; i < this.updatedItems.length; i++) {
				let item = this._.clone(this.updatedItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				updatedItemsNormilized.push(item);
			}

			var deletedItemsNormilized = [];
			for (let i = 0; i < this.deletedItems.length; i++) {
				let item = this._.clone(this.deletedItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				deletedItemsNormilized.push(item);
			}

			this.saveAlertVechilesAssociationRequest = ApiService.saveAlertVehiclesAssociation(createdItemsNormilized, updatedItemsNormilized, deletedItemsNormilized)
				.then(res => {
					self.clearWorkingData();
					self.getVehiclesByAlertId();

					self.isAlertDetailInEditMode = false;
					self.getData();
				})
				.catch(err => {})
				.finally(_ => {
					self.saveAlertVechilesAssociationRequest = null;
				});
		},
		dateStringToMomentFormat(dateString) {
			if (dateString.indexOf("/") >= 0) {
				return moment(dateString, "DD/MM/YYYY").format();
			}

			return moment(dateString).format();
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		isReadOnlyCell(field, item) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (item.id > 0 && c && c.readonly) {
					return true;
				}
			}

			return false;
		},

		getTypeAssociationById(typeId) {
			let type = this.alertVehicleTypes.find(function(item) {
				return item.id == typeId;
			});

			if (type) return type.value;

			return typeId;
		},
		getVehiclePlateCodeById(vehicleId) {
			let vehicle = this.vehicles.find(function(item) {
				return item.id == vehicleId;
			});

			if (vehicle) return vehicle.number_plate;

			return vehicleId;
		},
		getGroupNameById(groupId) {
			let group = this.groups.find(function(item) {
				return item.id == groupId;
			});

			if (group) return group.value;

			return groupId;
		},
		getDivisionNameById(divisionId) {
			let division = this.divisions.find(function(item) {
				return item.id == divisionId;
			});

			if (division) return division.value;

			return divisionId;
		},
		removeHourByDay(item, index) {
			if (index >= 0) {
				item.timeslots.splice(index, 1);
			}
		},
		addHourByDay(item, index) {
			if (this.isAlertDetailInEditMode) {
				//reset errors
				for (var i = 0; i < this.errorsStartTime.length; i++) {
					Vue.set(this.errorsStartTime, i, false);
					Vue.set(this.errorsEndTime, i, false);
				}

				var isValidRange = true;
				var errors = {
					messages: []
				};
				var startDateElementRef = `starttimepicker_${index}`;
				var endDateElementRef = `endtimepicker_${index}`;

				var startTime = this.$refs[startDateElementRef][0].$el.value;
				var endTime = this.$refs[endDateElementRef][0].$el.value;

				if (!startTime || !endTime) {
					errors.messages.push({ type: "error", text: "Specificare una data di inizio e fine per la fascia" });
					bus.$emit("responseNotification", errors);

					return;
				}

				var strStartTimeCheck = startTime.replace(":", "");
				if (isNaN(strStartTimeCheck)) {
					errors.messages.push({ type: "error", text: "Specificare una data di inizio valida per la fascia" });
					Vue.set(this.errorsStartTime, index, true);

					isValidRange = false;
				}

				var strEndTimeCheck = endTime.replace(":", "");
				if (isNaN(strEndTimeCheck)) {
					errors.messages.push({ type: "error", text: "Specificare una data di fine valida per la fascia" });
					Vue.set(this.errorsEndTime, index, true);

					isValidRange = false;
				}

				if (!isValidRange) {
					bus.$emit("responseNotification", errors);
					return;
				}

				var mStartTime = moment(startTime, "HH:mm");
				var mEndTime = moment(endTime, "HH:mm");

				if (mStartTime.isValid && mEndTime.isValid) {
					if (mStartTime > mEndTime) {
						Vue.set(this.errorsStartTime, index, true);
						Vue.set(this.errorsEndTime, index, true);

						errors.messages.push({ type: "error", text: "L'oraro di fine deve essere maggiore di quello di inizio" });
						bus.$emit("responseNotification", errors);
						return;
					}

					for (var i = 0; i < item.timeslots.length; i++) {
						let tt = item.timeslots[i];
						tt.error = false;
						let ttStartNow = moment(tt.from_time);
						let ttStartTime = moment(ttStartNow).format("HH:mm");

						let ttEndNow = moment(tt.to_time);
						let ttEndTime = moment(ttEndNow).format("HH:mm");

						let ttStartTimeNow = moment(ttStartTime, "HH:mm");
						let ttEndTimeNow = moment(ttEndTime, "HH:mm");

						if (ttStartTimeNow <= mEndTime && ttEndTimeNow >= mStartTime) {
							Vue.set(this.errorsStartTime, index, true);
							Vue.set(this.errorsEndTime, index, true);

							tt.error = true;

							errors.messages.push({ type: "error", text: "La fascia si sovrappone con una esistente" });
							bus.$emit("responseNotification", errors);
							return;
						}
					}

					item.timeslots.push({
						from_time: mStartTime.format(),
						to_time: mEndTime.format()
					});

					this.$refs[startDateElementRef][0].$el.value = "HH:mm";
					this.$refs[endDateElementRef][0].$el.value = "HH:mm";
				}
			}
		}
	},

	computed: {
		...mapGetters(["settings"]),
		columns: function() {
			return this.columnsTable;
		}
	}
};
